<template>
  <v-dialog
      v-model="$store.state.dialog.product"
      persistent
      max-width="700"
      overlay-opacity="0.8"
  >
    <v-card class="view">
      <v-container>
        <v-row>
          <v-col class="pb-0 pt-0">
            <v-btn fab small outlined color="primary" class="float-left"
                   @click="$store.commit('product_current',-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn fab small outlined color="primary" class="float-right"
                   @click="$store.commit('product_current',1)">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>

            <div class="ma-1 mt-0 ml-4 float-left headline">รหัส: {{ current_product.code }}
              <div class="caption">barcode: {{ current_product.erp_code2 }}</div>
            </div>


          </v-col>
        </v-row>


        <v-row>

          <v-col>
            ชื่อสินค้า: {{ current_product.nickname }}
            <span v-if="current_product.unit_primitive === 'CTN'"
                  class="red pl-1 pr-1" style="color: white">
        ยกหีบ
      </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="position: relative">
            <v-img
                v-if="current_product.image_path"
                :src="'/'+current_product.image_path+'.236.jpg'"
                :lazy-src="'/'+current_product.image_path+'.64.jpg'"
                aspect-ratio="1"
                class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <v-btn
                v-if="current_product.non_over_stock"
                class="ml-1 orange pa-1 caption"
                style="color: white;position: absolute;top: 0" x-small>
              !! สินค้าไม่ผลิตเพิ่ม
            </v-btn>

          </v-col>

          <v-col class="text-right">

            <div><span
                class="float-left">ชนิด </span>{{ current_product.type = 'F' ? 'สินค้าสำเร็จรูป' : 'สินค้าอื่นๆ' }}
            </div>

            <div><span class="float-left">กลุ่มสินค้า </span>{{
                current_product.type_code == 'TRAD_OFM' ? 'OFM' : current_product.group
              }}
            </div>
            <div><span class="float-left">สี</span>{{ current_product.color }}</div>
            <div><span class="float-left">ขนาด</span>{{ current_product.size }} ml</div>


            <div class="display-1 mt-8 mb-8">
              <div v-if="$store.state.carts.current.id">


                คลัง:
                {{
                  $helper.number_format(current_product['stock_MT'] *
                      current_product['unit_prim_rate'])
                }}
                {{ $helper.parseUnit(current_product['unit_primitive']) }}

                <br/>
                จอง:
                {{ $helper.number_format(current_product['reserve_MT']) }}
                {{ $helper.parseUnit(current_product['unit_primitive']) }}

              </div>
              <div v-else>

                <div class="mb-2">
                  คลัง {{
                    $helper.number_format(current_product['stock_MT'] *
                        current_product['unit_prim_rate'])
                  }} <span class="unit">{{ $helper.parseUnit(current_product['unit_primitive']) }}</span>
                  <br/>
                  จอง {{ $helper.number_format(current_product['reserve_MT']) }} <span
                    class="unit">{{ $helper.parseUnit(current_product['unit_primitive']) }}</span>


                </div>
                <!--<div>คลัง PJ {{$helper.number_format(current_product['stock_PJ'] * current_product['unit_prim_rate'])}} <span-->
                <!--class="unit">{{current_product['unit_primitive']}}</span></div>-->


              </div>


            </div>

            <div class="headline" v-if="$store.state.carts.current.id">
              <span v-if="$store.state.carts.current.price_group==8" class="float-left">ราคากลุ่มOFM</span>
              <span v-else-if="$store.state.carts.current.price_group==9" class="float-left">ราคากลุ่มKCCP</span>
              <span v-else-if="$store.state.carts.current.price_group==10" class="float-left">ราคากลุ่มKCCP+5%</span>
              <span v-else class="float-left">ราคากลุ่ม{{ $store.state.carts.current.price_group }}</span>
              {{ current_product['price_' + $store.state.carts.current.price_group] }} บาท
            </div>

            <div class="" v-else>
              <div  v-if="current_product['type_code']=='TRAD_OFM'" >
                <span class="float-left">ราคา OFM</span> {{ current_product['price_8'] }} บาท <br/>
                <span class="float-left">ราคา KCCP</span> {{ current_product['price_9'] }} บาท <br/>
                <span class="float-left">ราคา KCCP+5%</span> {{ current_product['price_10'] }} บาท <br/>
              </div>
              <div  v-else >
                <span class="float-left">ราคา 1</span> {{ current_product['price_1'] }} บาท <br/>
                <span class="float-left">ราคา 2</span> {{ current_product['price_2'] }} บาท <br/>
                <span class="float-left">ราคา 3</span> {{ current_product['price_3'] }} บาท <br/>
                <span class="float-left">ราคา 4</span> {{ current_product['price_4'] }} บาท <br/>
                <span class="float-left">ราคา 5</span> {{ current_product['price_5'] }} บาท <br/>
                <span class="float-left">ราคา 6</span> {{ current_product['price_6'] }} บาท <br/>
                <span class="float-left">ราคา 7</span> {{ current_product['price_7'] }} บาท <br/>
              </div>
            </div>


            <!--            <div class="headline" v-if="$store.state.carts.current.id">-->
            <!--              <span class="float-left">ราคาปลีก</span>{{current_product.price_retail}} บาท-->
            <!--            </div>-->

          </v-col>

        </v-row>

        <!--<v-row v-if="$store.state.carts.current.id">-->
        <!--<v-col class="text-right  display-1 pt-5">ราคาขาย</v-col>-->
        <!--<v-col>-->
        <!--<v-card-->
        <!--class="display-1 text-center pa-2"-->
        <!--outlined-->


        <!--&gt;-->
        <!--{{$store.state.carts.current.id && $store.state.carts.current_item_map[current_product.id]?-->
        <!--$store.state.carts.current_item_map[current_product.id].price_init:current_product.price_retail}}-->


        <!--</v-card>-->
        <!--</v-col>-->
        <!--<v-col class="col-2  display-1 pt-5">บาท</v-col>-->

        <!--</v-row>-->
        <v-row v-if="$store.state.carts.current.id">

          <v-col class="text-right display-1 pt-6">จำนวนสั่ง</v-col>
          <v-col>


            <div v-if="$store.state.carts.current_item_map[current_product.id]">

              <table width="100%">
                <tr>
                  <td>
                    <v-btn
                        fab tile width="100%"
                        class="primary"
                        @click.stop="onClickAddCart(current_product,-1)"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>

                  </td>
                  <td>
                    <v-card
                        class="display-1 text-center pa-2"
                        style="padding-bottom: 16px !important;padding-top: 0 !important;"
                        outlined
                        @click="onClickQuantity(current_product,
                        $store.state.carts.current_item_map[current_product.id].quantity)"
                    >
                      <!--<span style="position: absolute;">-->
                      {{ $store.state.carts.current_item_map[current_product.id].quantity }}
                      <!--</span>-->
                      <span
                          style="font-size: 0.5em;position: absolute;bottom: -11px;right: 0;display: block;width: 100%;text-align: center;">
                        {{ $helper.parseUnit(current_product.unit_primitive) }}
                      </span>
                    </v-card>
                  </td>
                  <td>

                    <v-btn
                        fab tile width="100%"
                        class="primary"
                        @click.stop="onClickAddCart(current_product,1)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </table>


            </div>
            <div v-else>
              <v-btn
                  fab tile width="100%"
                  class="primary"
                  :disabled="current_product.non_over_stock && current_product.stock_MT * current_product.unit_prim_rate-current_product.reserve_MT<=0"
                  @click.stop="onClickAddCart(current_product)"
              >
                เพิ่มเข้าตะกร้า
              </v-btn>

            </div>


          </v-col>
          <v-col class="col-2 pt-4">

            <v-btn fab tile class="close-button float-right" width="100%" color="primary"
                   @click="$store.commit('dialog_is_product',{toggle:false})">
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>

          </v-col>

        </v-row>

        <v-row v-else>
          <v-col>
            <v-btn class="disabled" width="100%">
              กรุณาสร้างตะกร้าก่อนเพิ่มสินค้า
            </v-btn>
          </v-col>
          <v-col class="col-2 pt-4">

            <v-btn fab tile class="close-button float-right" width="100%" color="primary"
                   @click="$store.commit('dialog_is_product',{toggle:false})">
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>

          </v-col>
        </v-row>

      </v-container>


    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.view {
  position: relative;
  /*background: #FF0000;*/
}

.unit {
  font-size: 0.5em;
}
</style>

<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'
import {Product} from '../models/Product'
import router from '../router'

@Component({
  components: {}
})
export default class ProductDialog extends Vue {

  get current_product(): Product {

    if (this.$store.state.products.data) {
      return this.$store.state.products.data[this.$store.state.products.current]
    }
    return new Product()
  }

  async onClickAddCart(product: Product, delta = 1) {
    if (this.$store.state.carts.current.id) {
      const item = await this.$store.dispatch('alter_item_to_cart', {product, delta})

      if (item instanceof Error) {
        const e: any = item
        console.log(e.response.data)
        if (e.response && e.response.data && e.response.data.message)
          this.$root.$emit('onWarning', {message: e.response.data.message, error: e})
        else
          this.$root.$emit('onError', {error: e})
        return
      }


    } else {
      router.push('/customer')
    }
  }


  async onClickQuantity(product: Product, quantity) {
    const start_qty = quantity
    this.$root.$emit('openCalculator', {
      number: quantity, onApply: async (number) => {
        this.$store.dispatch('alter_item_to_cart', {product, delta: number - start_qty})
      }
    })
  }

};

</script>
